(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addClassIfDoesntExist = addClassIfDoesntExist;
exports.convertNodeListToArray = convertNodeListToArray;
exports.decodeHTMLEntities = decodeHTMLEntities;
exports.detectDeviceType = detectDeviceType;
exports.formatYouTubeUrl = formatYouTubeUrl;
exports.removeClassIfExists = removeClassIfExists;
exports.removeDupsInAssociativeArrayByKey = removeDupsInAssociativeArrayByKey;
exports.removeHtmlComments = removeHtmlComments;
exports.removeUrlParams = removeUrlParams;
exports.sortArrayAlphabeticalByKey = sortArrayAlphabeticalByKey;
exports.webFriendlyName = webFriendlyName;
function removeUrlParams() {
  var newurl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname);
  window.history.replaceState({}, document.title, newurl);
}
function removeHtmlComments(html) {
  return html.replace(/<!--[\s\S]*?-->/g, "").trim();
}
function convertNodeListToArray(nodeList) {
  return Array.from(nodeList);
}
function webFriendlyName(text) {
  text = text.replace(/\s+/g, "-").toLowerCase();
  text = text.replace(/[^a-z0-9\-]+/gi, "");
  return text;
}
function removeDupsInAssociativeArrayByKey(array, key) {
  var newArray = [];
  var uniqueObject = {};
  var i = 0;
  for (var _i in array) {
    var obj = array[_i][key];
    uniqueObject[obj] = array[_i];
    _i++;
  }
  for (i in uniqueObject) if (i !== "undefined") newArray.push(uniqueObject[i]);
  return newArray;
}
function sortArrayAlphabeticalByKey(array, key) {
  if (!key) key = "text";
  array.sort(function (a, b) {
    if (a[key] > b[key]) return 1;
    if (a[key] < b[key]) return -1;
    return 0;
  });
}
function decodeHTMLEntities(html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}
function addClassIfDoesntExist(element, className) {
  if (!!element && !element.classList.contains(className)) element.classList.add(className);
}
function removeClassIfExists(element, className) {
  if (!!element && element.classList.contains(className)) element.classList.remove(className);
}
function formatYouTubeUrl(url) {
  var videoCode;
  var youTubeUrl = "https://www.youtube.com/watch?v=";
  if (url.indexOf("embed") !== -1) {
    var array = url.split("embed/");
    var _videoCode = !!array[1] ? array[1].split("?")[0] : "";
    if (!!_videoCode) url = "".concat(youTubeUrl).concat(_videoCode);
  }
  return url;
}
function detectDeviceType() {
  // window variables are set when farmers.js is loaded
  var deviceType = "";
  if (window.is_mobile_device && !window.is_iPad) deviceType = "phone";
  if (window.is_iPad) deviceType = "ipad";
  if (!window.is_mobile_device && !window.is_iPad) deviceType = "desktop";
  return deviceType;
}

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPageLanguageCode = getPageLanguageCode;
function getPageLanguageCode() {
  return document.querySelector("html").getAttribute("lang");
}

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cawSetNumberOfSelections = cawSetNumberOfSelections;
function cawSetNumberOfSelections() {
  var filterCountDisplay = document.querySelector(".caw-filters-count");
  if (!!filterCountDisplay) filterCountDisplay.innerHTML = "(".concat(document.querySelectorAll('[id*="edit-field-caw-tags-target-id"] input:checked').length, ")");
}

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alignBackToTopWithFeedbackWidget = alignBackToTopWithFeedbackWidget;
exports.bfrJourneyLinkIds = bfrJourneyLinkIds;
exports.cardHeaderUnderlineSetHeight = cardHeaderUnderlineSetHeight;
exports.moveCawDropdown = moveCawDropdown;
exports.runFunctionsOnLoad = runFunctionsOnLoad;
exports.setImageCaptionWidth = setImageCaptionWidth;
exports.setLeftMarginForFeedbackMockButton = setLeftMarginForFeedbackMockButton;
window.addEventListener("resize", function (event) {
  cardHeaderUnderlineSetHeight();
  setLeftMarginForFeedbackMockButton();
  alignBackToTopWithFeedbackWidget();
});
function runFunctionsOnLoad() {
  cardHeaderUnderlineSetHeight();
  setImageCaptionWidth();
  setLeftMarginForFeedbackMockButton();
  alignBackToTopWithFeedbackWidget();
  bfrJourneyLinkIds();
}
function cardHeaderUnderlineSetHeight() {
  var contentGridItems = document.querySelectorAll(".content-grid .content-grid-items");
  if (!!contentGridItems.length) {
    contentGridItems.forEach(function (item) {
      if (item.querySelector(".yellow-line")) {
        var rows = item.querySelectorAll(".row [class*='medium-']");
        rows.forEach(function (row) {
          row.parentElement.classList.add("minus-mx-6");
          row.classList.add("px-6");
        });
        var itemsPerRow = item.getAttribute("data-items-per-row");
        var headers = item.querySelectorAll(".card-underlined-header");
        var headerHeights = [];
        headers.forEach(function (header, index) {
          var headerIndex = Math.floor(index / itemsPerRow);
          var currentHeight = header.getBoundingClientRect().height;
          if (currentHeight > headerHeights[headerIndex] || !headerHeights[headerIndex]) headerHeights[headerIndex] = header.getBoundingClientRect().height;
        });
        headers.forEach(function (header, index) {
          var headerIndex = Math.floor(index / itemsPerRow);
          var headerHeight = "".concat(headerHeights[headerIndex], "px");
          if (!!headerHeight) {
            if (window.innerWidth > 768) header.style.height = headerHeight;
            if (window.innerWidth <= 768) header.style.height = "initial";
          }
        });
      }
    });
  }
}
function setImageCaptionWidth() {
  var captionContainers = document.querySelectorAll("figure.img-caption");
  captionContainers.forEach(function (captionContainer) {
    var img = captionContainer.querySelector("img");
    if (!!img) {
      img.addEventListener("load", function () {
        var caption = captionContainer.querySelector("figcaption");
        if (!!caption) caption.style.width = "".concat(img.width, "px");
      });
    }
  });
}
function moveCawDropdown() {
  var form = document.getElementById("views-exposed-form-conservation-at-work-videos-conservation-at-work-videos");
  var sortBy = form.querySelector(".form-item-sort-by");
  if (!!form && !!sortBy) form.append(sortBy);
}
function setLeftMarginForFeedbackMockButton() {
  var button = document.getElementById("QSIFeedbackButton-btn-mock");
  if (!!button) {
    var dimensions = button.getBoundingClientRect();
    var left = window.innerWidth / 10;
    left = left * 9;
    left = left - dimensions.width + 16;
    button.style.left = "".concat(Math.round(left), "px");
  }
}
function alignBackToTopWithFeedbackWidget() {
  var retry_number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var button = document.querySelector("[id*='QSIFeedbackButton-btn']");
  var backToTop = document.querySelector(".back-to-top.sitewide");

  // check for elements 5 times before giving up.
  // Feedback button Will be dynamic on production.
  if ((!backToTop || !button) && retry_number < 5) {
    setTimeout(function () {
      alignBackToTopWithFeedbackWidget(retry_number + 1);
    }, 350);
  }
  if (!!button) {
    var styles = window.getComputedStyle(button, null).getPropertyValue("left");
    var buttonDimensions = button.getBoundingClientRect();
    var backToTopDimensions = backToTop.getBoundingClientRect();
    // align the button with the right edge of the feedback button
    backToTop.style.left = "".concat(parseInt(button.style.left) + (buttonDimensions.width - backToTopDimensions.width), "px");
  }
}
function bfrJourneyLinkIds() {
  var bfrJourneyContainers = document.querySelectorAll(".category-slides.bfr-journey");
  if (!!bfrJourneyContainers) {
    bfrJourneyContainers.forEach(function (row, idx) {
      row.querySelectorAll("a").forEach(function (link) {
        link.id = "".concat(link.id, "-").concat(idx + 1);
      });
    });
  }
}

},{}],5:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.langSwitcherShowText = langSwitcherShowText;
var ds_multilingual_utils = _interopRequireWildcard(require("../../farmers-gov-design-system/js/_utils/multilingual_utils"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function langSwitcherShowText() {
  var langSwitcher = document.querySelector(".language-switcher");
  if (!!langSwitcher) {
    var pageLangCode = ds_multilingual_utils.getPageLanguageCode();
    var englishText = langSwitcher.querySelector(".en-text");
    var spanishText = langSwitcher.querySelector(".es-text");
    if (pageLangCode === "es") {
      if (!!englishText) englishText.style.display = "block";
      if (!!spanishText) spanishText.style.display = "none";
    }
    if (pageLangCode === "en") {
      if (!!englishText) englishText.style.display = "none";
      if (!!spanishText) spanishText.style.display = "block";
    }
  }
}

},{"../../farmers-gov-design-system/js/_utils/multilingual_utils":2}],6:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeBannerOnEnter = closeBannerOnEnter;
exports.handleSiteBannerDismissLink = handleSiteBannerDismissLink;
exports.setSiteBannerVisibility = setSiteBannerVisibility;
var general_utils = _interopRequireWildcard(require("../../farmers-gov-design-system/js/_utils/general_utils"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function setSiteBannerVisibility() {
  var siteBannerStorageName = "hide_site_banner";
  var show = window.localStorage.getItem(siteBannerStorageName) === getAlertText() ? false : true;
  if (show) {
    var banner = document.querySelector(".site-messages .farmers-banner");
    if (banner) banner.classList.add("show");
    window.localStorage.removeItem(siteBannerStorageName);
  }
}
function handleSiteBannerDismissLink() {
  var dismissLink = document.querySelector(".site-messages .farmers-banner-dismiss");
  if (dismissLink) dismissLink.addEventListener("click", function (event) {
    hideBanner();
  });
}
function getAlertText() {
  var siteBanner = document.querySelector(".site-messages .farmers-banner-description");
  var string = "";
  if (siteBanner) string = general_utils.removeHtmlComments(siteBanner.innerHTML.trim().toLowerCase());
  return string.replace(/[^a-z0-9]/gi, "");
}
function closeBannerOnEnter() {
  var promoBannerDismissLink = document.querySelector(".farmers-banner-dismiss");
  if (promoBannerDismissLink) {
    promoBannerDismissLink.addEventListener("keyup", function (event) {
      if (event.key.toLowerCase() === "enter") hideBanner();
    });
  }
}
function hideBanner() {
  window.localStorage.setItem("hide_site_banner", getAlertText());
  document.querySelector(".site-messages .farmers-banner").classList.remove("show");
}

},{"../../farmers-gov-design-system/js/_utils/general_utils":1}],7:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blogFiltersSetNumberOfSelections = blogFiltersSetNumberOfSelections;
exports.setCheckboxesUsingInherentFilters = setCheckboxesUsingInherentFilters;
exports.updateBlogCategoriesUrlParams = updateBlogCategoriesUrlParams;
exports.updateFormInputsFromUrlParams = updateFormInputsFromUrlParams;
var general_utils = _interopRequireWildcard(require("../../../farmers-gov-design-system/js/_utils/general_utils"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function setCheckboxesUsingInherentFilters() {
  var selectedCategoryFilters = document.querySelectorAll("#inherent-filters select[id*='edit-tid'] option:checked");
  selectedCategoryFilters.forEach(function (element) {
    document.querySelector(".view-multi-select-blog-category-carousel div[data-termid='".concat(element.value, "']")).classList.add("active");
  });
  var selectedCommodityFilters = document.querySelectorAll("#inherent-filters select[id*='edit-commodity'] option:checked");
  selectedCommodityFilters.forEach(function (element) {
    setCheckboxValues(element.value);
  });
  var selectedProducerFilters = document.querySelectorAll("#inherent-filters select[id*='edit-producer'] option:checked");
  selectedProducerFilters.forEach(function (element) {
    setCheckboxValues(element.value);
  });
  updateBlogCategoriesUrlParams(selectedCommodityFilters, selectedProducerFilters);
}
function updateBlogCategoriesUrlParams(commodity, producer) {
  if (!onBlogFiltersPage()) return;
  general_utils.removeUrlParams();
  var queryString = [];
  var stateDropdownChecked = document.querySelector("#inherent-filters select[id*='edit-state'] option:checked");
  var stateValue = !!stateDropdownChecked ? stateDropdownChecked.value : "";
  var categories = document.querySelectorAll("#inherent-filters select[id*='edit-tid'] option:checked");
  var categoryValues = [];
  var commValues = [];
  var prodValues = [];
  categories.forEach(function (cat) {
    categoryValues.push(cat.value);
  });
  commodity.forEach(function (comm) {
    commValues.push(comm.value);
  });
  producer.forEach(function (prod) {
    prodValues.push(prod.value);
  });
  if (!!stateValue && stateValue !== "All") queryString.push("state=".concat(stateValue));
  if (!!categoryValues.length) queryString.push("cat=".concat(categoryValues.join("+")));
  if (!!commValues.length) queryString.push("comm=".concat(commValues.join("+")));
  if (!!prodValues.length) queryString.push("prod=".concat(prodValues.join("+")));
  if (!!queryString.length) {
    var newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?").concat(queryString.join("&"));
    window.history.pushState({
      path: newUrl
    }, "", newUrl);
  }
}
function updateFormInputsFromUrlParams() {
  if (!onBlogFiltersPage()) return;
  // only set these on page load/reload
  window.addEventListener("load", function (event) {
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var categoryValues = urlParams.get("cat");
    var stateValue = urlParams.get("state");
    var commodityValues = urlParams.get("comm");
    var producerValues = urlParams.get("prod");
    var valuesCheck = 0;
    if (!!categoryValues) {
      valuesCheck++;
      var array = categoryValues.split(" ");
      array.forEach(function (value) {
        document.querySelector("option[value=\"".concat(value, "\"]")).setAttribute("selected", "true");
        document.querySelector(".category-slide[data-termid=\"".concat(value, "\"]")).classList.add("active");
      });
    }
    if (!!stateValue) {
      valuesCheck++;
      document.querySelectorAll("select.view-state-mobile-filters option[value=\"".concat(stateValue, "\"]")).forEach(function (dropdown) {
        dropdown.setAttribute("selected", "true");
      });
    }
    if (!!commodityValues) {
      valuesCheck++;
      var _array = commodityValues.split(" ");
      _array.forEach(function (value) {
        document.querySelector("#inherent-filters select[id*='edit-commodity'] option[value='".concat(value, "']")).setAttribute("selected", "true");
        setCheckboxValues(value);
      });
    }
    if (!!producerValues) {
      valuesCheck++;
      var _array2 = producerValues.split(" ");
      _array2.forEach(function (value) {
        document.querySelector("#inherent-filters select[id*='edit-producer'] option[value='".concat(value, "']")).setAttribute("selected", "true");
        setCheckboxValues(value);
      });
    }
    var blogFiltersSubmit = document.querySelector(".views-exposed-form input[type=submit]");
    if (!urlParams.get("term") && blogFiltersSubmit && valuesCheck > 0) blogFiltersSubmit.click();
  });
}
function blogFiltersSetNumberOfSelections() {
  var filterCountDisplay = document.querySelector(".blog-filters-count");
  var categorySelect = document.querySelectorAll(".view-multi-select-blog-category-carousel .category-slide.active").length;
  var stateSelect = document.querySelectorAll('#inherent-filters select[id*="edit-state"] option:not([value="All"]):checked').length;
  var commoditiesSelected = document.querySelectorAll('#inherent-filters select[id*="edit-commodity"] option:checked').length;
  var producersSelected = document.querySelectorAll('#inherent-filters select[id*="edit-producer"] option:checked').length;
  if (!!filterCountDisplay) {
    var selectedCount = Number(categorySelect) + Number(stateSelect) + Number(commoditiesSelected) + Number(producersSelected);
    filterCountDisplay.innerHTML = "(".concat(selectedCount, ")");
  }
}
function setCheckboxValues(value) {
  var checkboxes = document.querySelectorAll("input[value=\"".concat(value, "\""));
  checkboxes.forEach(function (checkbox) {
    checkbox.setAttribute("checked", "");
  });
}
function onBlogFiltersPage() {
  var onPage = false;
  if (window.location.pathname === "/blog") onPage = true;
  return onPage;
}

},{"../../../farmers-gov-design-system/js/_utils/general_utils":1}],8:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var checkboxes = _interopRequireWildcard(require("./checkboxes"));
var radioButtons = _interopRequireWildcard(require("./radio_buttons"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// This file is for keeping legacy JS from the design system for elements
// that may still be present on the site.

checkboxes.checkboxes();
radioButtons.radioButtons();

},{"./checkboxes":9,"./radio_buttons":10}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkboxes = checkboxes;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function checkboxes() {
  window.addEventListener("load", function () {
    document.addEventListener("click", function (evt) {
      var cb_labels = _toConsumableArray(document.querySelectorAll("label.checkbox-card-label"));
      cb_labels.map(function (el) {
        var target = evt.target;
        target.parentElement.classList.contains("checkbox-card-label") ? target = target.parentElement : !!target.parentElement.parentElement && target.parentElement.parentElement.classList.contains("checkbox-card-label") ? target = target.parentElement.parentElement : "";
        if (target === el) {
          if (!target.classList.contains("disabled")) {
            if (target.control.checked) {
              target.classList.add("checked");
            } else {
              target.classList.remove("checked");
            }
          }
        }
      });
    });
    document.addEventListener("keydown", function (evt) {
      var cb_labels = _toConsumableArray(document.querySelectorAll("label.checkbox-card-label, label.checkbox-label"));
      cb_labels.map(function (el) {
        var target = evt.target;
        target.parentElement.classList.contains("checkbox-card-label") ? target = target.parentElement : !!target.parentElement.parentElement && target.parentElement.parentElement.classList.contains("checkbox-card-label") ? target = target.parentElement.parentElement : "";
        if (el === target) {
          var key = evt.which.toString();
          if (key.match(/32|13/)) {
            evt.preventDefault();
            target.click();
          }
        }
      });
    });
  });
}

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.radioButtons = radioButtons;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function radioButtons() {
  window.addEventListener("load", function () {
    document.addEventListener("click", function (evt) {
      var radio_labels = _toConsumableArray(document.querySelectorAll("label.radio-card-label"));
      radio_labels.map(function (el) {
        var target = evt.target;
        target.parentElement.classList.contains("radio-card-label") ? target = target.parentElement : !!target.parentElement.parentElement && target.parentElement.parentElement.classList.contains("radio-card-label") ? target = target.parentElement.parentElement : "";
        if (target === el) {
          if (el.classList.contains("disabled")) {
            el.control.disabled = true;
          }
          el.querySelector(".radio-card-input").addEventListener("change", function (evt) {
            var radio_name = evt.target.name;
            var rel_radios = _toConsumableArray(document.querySelectorAll("input.radio-card-input[name=".concat(radio_name, "]")));
            rel_radios.map(function (item) {
              _toConsumableArray(item.labels).map(function (label) {
                if (item.checked) label.classList.add("checked");
                if (!item.checked) label.classList.remove("checked");
              });
            });
          });
        }
        target.focus();
      });
    });
    document.addEventListener("keydown", function (evt) {
      var radio_labels = _toConsumableArray(document.querySelectorAll("label.radio-card-label"));
      radio_labels.map(function (el) {
        var target = evt.target;
        target.parentElement.classList.contains("radio-card-label") ? target = target.parentElement : !!target.parentElement.parentElement && target.parentElement.parentElement.classList.contains("radio-card-label") ? target = target.parentElement.parentElement : "";
        if (target === el) {
          var key = evt.which.toString();
          if (key.match(/32|13/)) {
            evt.preventDefault();
            el.click();
          }
        }
        target.focus();
      });
    });
  });
}

},{}],11:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var site_banner_utils = _interopRequireWildcard(require("./_utils/_site_banner_utils"));
var caw_utils = _interopRequireWildcard(require("./_utils/_caw_utils"));
var element_utils = _interopRequireWildcard(require("./_utils/_element-utils"));
var multilingual_utils = _interopRequireWildcard(require("./_utils/_multilingual_utils"));
var legacy = _interopRequireWildcard(require("./ds-legacy/_ds-legacy"));
var blogs = _interopRequireWildcard(require("./farmers_blog"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// import "../dist/js/farmers.min.js";
// import "../dist/js/farmers-stepper.min.js";

(function ($, Drupal) {
  blogs.fgBlogs($, Drupal);
  Drupal.behaviors.viewsScrollOff = {
    attach: function attach() {
      if (!!Drupal.AjaxCommands) Drupal.AjaxCommands.prototype.viewsScrollTop = null;
    }
  };
  $(document).ready(function () {
    site_banner_utils.setSiteBannerVisibility();
    site_banner_utils.handleSiteBannerDismissLink();
    site_banner_utils.closeBannerOnEnter();
    // caw_utils.cawSetNumberOfSelections();
    element_utils.runFunctionsOnLoad();
    if (document.querySelector(".caw-allvideos-page-01")) element_utils.moveCawDropdown();
    multilingual_utils.langSwitcherShowText();
    $(".accordion-block-full-width").find("a").attr("tabindex", "-1");
    $(".accordion-block-wrap button").click(function () {
      var textLess = $(this).find("a");
      textLess.toggleClass("active");
      if (textLess.hasClass("active")) {
        $(this).parent().find(".accordion-block-full-width").find("a").attr("tabindex", "0");
        textLess.text("Show Less");
        textLess.ariaLabel("Show Less");
      } else {
        $(this).parent().find(".accordion-block-full-width").find("a").attr("tabindex", "-1");
        textLess.text("Show More");
        textLess.ariaLabel("Show More");
      }
    });

    // setup feedback buttons functionality
    $("#helpful-btns button").click(function () {
      $("#helpful-btns .help-inner-wrap").hide();
      $("#helpful-btns .help-feedback").addClass("active").fadeIn(600);
    });
    var max_chars = 5;
    $("#zip").keydown(function (e) {
      if ($(this).val().length >= max_chars) {
        $(this).val($(this).val().substr(0, max_chars));
      }
      var charCode = e.which ? e.which : event.keyCode;
      if (charCode === 9) {
        return true;
      }
      if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
      var evt = "";
      var theEvent = evt || window.event;
      var theVal = theEvent.target.value;
      var key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
      if (key.length == 0) return;
      var regex = /^[0-9.,\b]+$/;
      if (!regex.test(key)) {
        if (theEvent.preventDefault) theEvent.preventDefault();
        return false;
      }
      return true;
    });
    $("#zip").keyup(function (e) {
      if ($(this).val().length >= max_chars) {
        $(this).val($(this).val().substr(0, max_chars));
      }
      var charCode = e.which ? e.which : event.keyCode;
      if (charCode === 9) {
        return true;
      }
      if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
      return true;
    });
    $("#weather-search").click(function (e) {
      e.preventDefault();
      var data = "";
      var zip = $("#zip").val();
      var url = "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates?Postal=" + zip + "&f=pjson";
      $.getJSON(url).done(function (data) {
        //console.log(data);
        //console.log(data.candidates.length);
        if (data.candidates.length == "0") {
          //console.log('Zip code not valid.');
          alert("Zip code not valid.");
          return;
        }
        var x = data.candidates["0"].location.x;
        var y = data.candidates["0"].location.y;
        $.getJSON("https://forecast.weather.gov/MapClick.php?&lat=" + y + "&lon=" + x + "&FcstType=json").done(function (weather) {
          //console.log('https://forecast.weather.gov/MapClick.php?&lat=' + y + '&lon=' + x + '&FcstType=json');
          //console.log(weather.time);
          if (weather.success == false) {
            //console.log('Weather not found for this location. Choose another.');
            alert("Weather not found for this location. Choose another.");
            return;
          }
          $("#temp").html(weather.currentobservation.Temp + "&#176;");
          $("#location").html(weather.location.areaDescription);
          var obs = weather.currentobservation.Weather;
          if (obs == "") {
            obs = weather.data.weather["0"];
          }
          var icon = "";
          switch (obs) {
            case "Sunny":
            case "Fair":
            case "Clear":
            case "Fair with Haze":
            case "Clear with Haze":
            case "Mostly Clear":
            case "Fair and Breezy":
            case "Clear and Breezy":
              icon = "fair-clear-fair-clear-haze-fair-breezy-clear-breezy.svg";
              break;
            case "Mostly Cloudy":
            case "Mostly Cloudy with Haze":
            case "Mostly Cloudy and Breezy":
            case "A Few Clouds":
            case "Chance T-storms":
            case "A Few Clouds with Haze":
            case "A Few Clouds and Breezy":
            case "Partly Cloudy":
            case "Partly Cloudy with Haze":
            case "Partly Cloudy and Breezy":
            case "Partly Cloudy then Slight Chance Showers":
            case "Chance T-storms then Chance Showers":
              icon = "few-cloudy-haze-breezy.svg";
              break;
            case "Overcast":
            case "Overcast with Haze":
            case "Overcast and Breezy":
              icon = "overcast-haze-breezy.svg";
              break;
            case "Fog/Mist":
            case "Fog":
            case "Freezing Fog":
            case "Shallow Fog":
            case "Partial Fog":
            case "Patches of Fog":
            case "Patchy Fog then Sunny":
            case "Patchy Fog":
            case "Fog in Vicinity":
            case "Freezing Fog in Vicinity":
            case "Shallow Fog in Vicinity":
            case "Partial Fog in Vicinity":
            case "Patches of Fog in Vicinity":
            case "Showers in Vicinity Fog":
            case "Heavy Freezing Fog":
            case "Light Freezing Fog":
              icon = "fog-mist.svg";
              break;
            case "Smoke":
              icon = "smoke.svg";
              break;
            case "Freezing Rain":
            case "Freezing Drizzle":
            case "Light Freezing Rain":
            case "Light Freezing Drizzle":
            case "Heavy Freezing Rain":
            case "Heavy Freezing Drizzle":
            case "Freezing Rain in Vicinity":
            case "Freezing Drizzle in Vicinity":
            case "Ice Pellets":
            case "Light Ice Pellets":
            case "Heavy Ice Pellets":
            case "Ice Pellets in Vicinity":
            case "Showers Ice Pellets":
            case "Thunderstorm Ice Pellets":
            case "Ice Crystals":
            case "Hail":
            case "Small Hail/Snow Pellets":
            case "Light Small Hail/Snow Pellets":
            case "Heavy small Hail/Snow Pellets":
            case "Showers Hail":
            case "Hail Showers":
            case "Freezing Rain Snow":
            case "Light Freezing Rain Snow":
            case "Heavy Freezing Rain Snow":
            case "Freezing Drizzle Snow":
            case "Light Freezing Drizzle Snow":
            case "Heavy Freezing Drizzle Snow":
            case "Snow Freezing Rain":
            case "Light Snow Freezing Rain":
            case "Heavy Snow Freezing Rain":
            case "Snow Freezing Drizzle":
            case "Light Snow Freezing Drizzle":
            case "Heavy Snow Freezing Drizzle":
            case "Rain Ice Pellets":
            case "Light Rain Ice Pellets":
            case "Heavy Rain Ice Pellets":
            case "Drizzle Ice Pellets":
            case "Light Drizzle Ice Pellets":
            case "Heavy Drizzle Ice Pellets":
            case "Ice Pellets Rain":
            case "Light Ice Pellets Rain":
            case "Heavy Ice Pellets Rain":
            case "Ice Pellets Drizzle":
            case "Light Ice Pellets Drizzle":
            case "Heavy Ice Pellets Drizzle":
            case "Rain Snow":
            case "Light Rain Snow":
            case "Heavy Rain Snow":
            case "Snow Rain":
            case "Light Snow Rain":
            case "Heavy Snow Rain":
            case "Drizzle Snow":
            case "Light Drizzle Snow":
            case "Snow Drizzle":
            case "Light Snow Drizzle":
            case "Heavy Drizzle Snow":
              icon = "freezing-rain-ice.svg";
              break;
            case "Rain Showers":
            case "Light Rain Showers":
            case "Light Rain and Breezy":
            case "Heavy Rain Showers":
            case "Rain Showers in Vicinity":
            case "Light Showers Rain":
            case "Heavy Showers Rain":
            case "Showers Rain":
            case "Showers Rain in Vicinity":
            case "Rain Showers Fog/Mist":
            case "Light Rain Showers Fog/Mist":
            case "Heavy Rain Showers Fog/Mist":
            case "Rain Showers in Vicinity Fog/Mist":
            case "Light Showers Rain Fog/Mist":
            case "Heavy Showers Rain Fog/Mist":
            case "Showers Rain Fog/Mist":
            case "Showers Rain in Vicinity Fog/Mist":
              icon = "rain-showers.svg";
              break;
            case "Thunderstorm":
            case "Thunderstorm Rain":
            case "Light Thunderstorm Rain":
            case "Heavy Thunderstorm Rain":
            case "Light Thunderstorm Rain Fog/Mist":
            case "Heavy Thunderstorm Rain Fog and Windy":
            case "Heavy Thunderstorm Rain Fog/Mist":
            case "Light Thunderstorm Rain Haze":
            case "Heavy Thunderstorm Rain Haze":
            case "Light Thunderstorm Rain Fog":
            case "Heavy Thunderstorm Rain Fog":
            case "Thunderstorm Light Rain":
            case "Thunderstorm Heavy Rain":
            case "Thunderstorm Rain Fog/Mist":
            case "Thunderstorm Light Rain Fog/Mist":
            case "Thunderstorm Heavy Rain Fog/Mist":
            case "Thunderstorm in Vicinity Fog/Mist":
            case "Thunderstorm Showers in Vicinity":
            case "Thunderstorm Haze in Vicinity":
            case "Thunderstorm Light Rain Haze":
            case "Thunderstorm Heavy Rain Haze":
            case "Thunderstorm Fog":
            case "Thunderstorm Light Rain Fog":
            case "Thunderstorm Heavy Rain Fog":
            case "Thunderstorm Hail":
            case "Light Thunderstorm Rain Hail":
            case "Heavy Thunderstorm Rain Hail":
            case "Light Thunderstorm Rain Hail Fog/Mist":
            case "Heavy Thunderstorm Rain Hail Fog/Hail":
            case "Thunderstorm Showers in Vicinity Hail":
            case "Light Thunderstorm Rain Hail Haze":
            case "Heavy Thunderstorm Rain Hail Haze":
            case "Light Thunderstorm Rain Hail Fog":
            case "Heavy Thunderstorm Rain Hail Fog":
            case "Thunderstorm Light Rain Hail":
            case "Thunderstorm Heavy Rain Hail":
            case "Thunderstorm Rain Hail Fog/Mist":
            case "Thunderstorm Light Rain Hail Fog/Mist":
            case "Thunderstorm Heavy Rain Hail Fog/Mist":
            case "Thunderstorm in Vicinity Hail":
            case "Thunderstorm in Vicinity Hail Haze":
            case "Thunderstorm Haze in Vicinity Hail":
            case "Thunderstorm Light Rain Hail Haze":
            case "Thunderstorm Heavy Rain Hail Haze":
            case "Thunderstorm Hail Fog":
            case "Thunderstorm Light Rain Hail Fog":
            case "Thunderstorm Heavy Rain Hail Fog":
            case "Thunderstorm Small Hail/Snow Pellets":
            case "Thunderstorm Rain Small Hail/Snow Pellets":
            case "Light Thunderstorm Rain Small Hail/Snow Pellets":
            case "Heavy Thunderstorm Rain Small Hail/Snow Pellets":
              icon = "Tstorm.svg";
              break;
            case "Snow":
            case "Light Snow":
            case "Heavy Snow":
            case "Snow Showers":
            case "Light Snow Showers":
            case "Heavy Snow Showers":
            case "Showers Snow":
            case "Light Showers Snow":
            case "Heavy Showers Snow":
            case "Snow Fog/Mist":
            case "Light Snow Fog/Mist":
            case "Heavy Snow Fog/Mist":
            case "Snow Showers Fog/Mist":
            case "Light Snow Showers Fog/Mist":
            case "Heavy Snow Showers Fog/Mist":
            case "Showers Snow Fog/Mist":
            case "Light Showers Snow Fog/Mist":
            case "Heavy Showers Snow Fog/Mist":
            case "Snow Fog":
            case "Light Snow Fog":
            case "Heavy Snow Fog":
            case "Snow Showers Fog":
            case "Light Snow Showers Fog":
            case "Heavy Snow Showers Fog":
            case "Showers Snow Fog":
            case "Light Showers Snow Fog":
            case "Heavy Showers Snow Fog":
            case "Showers in Vicinity Snow":
            case "Snow Showers in Vicinity":
            case "Snow Showers in Vicinity Fog/Mist":
            case "Snow Showers in Vicinity Fog":
            case "Low Drifting Snow":
            case "Blowing Snow":
            case "Snow Low Drifting Snow":
            case "Snow Blowing Snow":
            case "Light Snow Low Drifting Snow":
            case "Light Snow Blowing Snow":
            case "Light Snow Blowing Snow Fog/Mist":
            case "Heavy Snow Low Drifting Snow":
            case "Heavy Snow Blowing Snow":
            case "Thunderstorm Snow":
            case "Light Thunderstorm Snow":
            case "Heavy Thunderstorm Snow":
            case "Snow Grains":
            case "Light Snow Grains":
            case "Heavy Snow Grains":
            case "Heavy Blowing Snow":
            case "Blowing Snow in Vicinity":
              icon = "snow.svg";
              break;
            case "Windy":
            case "Breezy":
            case "Fair and Windy":
            case "A Few Clouds and Windy":
            case "Partly Cloudy and Windy":
            case "Mostly Cloudy and Windy":
            case "Overcast and Windy":
              icon = "windy-breezy.svg";
              break;
            case "Showers in Vicinity":
            case "Showers in Vicinity Fog":
            case "Showers in Vicinity Fog/Mist":
            case "Showers in Vicinity Haze":
              icon = "rain-showers.svg";
              break;
            case "Freezing Rain Rain":
            case "Light Freezing Rain Rain":
            case "Heavy Freezing Rain Rain":
            case "Rain Freezing Rain":
            case "Light Rain Freezing Rain":
            case "Heavy Rain Freezing Rain":
            case "Freezing Drizzle Rain":
            case "Light Freezing Drizzle Rain":
            case "Heavy Freezing Drizzle Rain":
            case "Rain Freezing Drizzle":
            case "Light Rain Freezing Drizzle":
            case "Heavy Rain Freezing Drizzle":
              icon = "freezing-rain-ice.svg";
              break;
            case "Thunderstorm in Vicinity":
            case "Thunderstorm in Vicinity Fog":
            case "Thunderstorm in Vicinity Haze":
              icon = "Tstorm.svg";
              break;
            case "Light Rain":
            case "Drizzle":
            case "Light Drizzle":
            case "Heavy Drizzle":
            case "Light Rain Fog/Mist":
            case "Drizzle Fog/Mist":
            case "Light Drizzle Fog/Mist":
            case "Heavy Drizzle Fog/Mist":
            case "Light Rain Fog":
            case "Drizzle Fog":
            case "Light Drizzle Fog":
            case "Heavy Drizzle Fog":
            case "Rain":
            case "Heavy Rain":
            case "Rain Fog/Mist":
            case "Heavy Rain Fog/Mist":
            case "Rain Fog":
            case "Heavy Rain Fog":
              icon = "light-rain-drizzle.svg";
              break;
            case "Funnel Cloud":
            case "Funnel Cloud in Vicinity":
            case "Tornado/Water Spout":
              icon = "funnel-cloud.svg";
              break;
            case "Dust":
            case "Low Drifting Dust":
            case "Blowing Dust":
            case "Sand":
            case "Blowing Sand":
            case "Low Drifting Sand":
            case "Dust/Sand Whirls":
            case "Dust/Sand Whirls in Vicinity":
            case "Dust Storm":
            case "Heavy Dust Storm":
            case "Dust Storm in Vicinity":
            case "Sand Storm":
            case "Heavy Sand Storm":
            case "Sand Storm in Vicinity":
              icon = "dust.svg";
              break;
            case "Haze":
              icon = "haze.svg";
              break;
          }
          $("#icon").html('<img src="/themes/usda/js/farmers/weather-icons/' + icon + '"/>');
          $("#condition").html(obs);
          var lo = weather.data.temperature["1"] + "&#176;";
          var hi = weather.data.temperature["0"] + "&#176;";

          //console.log('hi: ' + hi);
          //console.log('lo: ' + lo);

          var tempLabelone = weather.time.tempLabel["0"];
          //var tempLabeltwo = weather.time.tempLabel['1'];

          if (tempLabelone === "High") {
            $("#hiandlow").html(hi + "/" + lo + " high/low");
          } else {
            $("#hiandlow").html(lo + "/" + hi + " high/low");
          }
          $("#time").html(weather.currentobservation.Date);
          var windD = parseInt(weather.currentobservation.Windd);
          var direction = "";
          var windString = "";
          if (windD > 340 && windD < 29) {
            direction = "N";
          } else if (windD > 30 && windD < 69) {
            direction = "NE";
          } else if (windD > 70 && windD < 129) {
            direction = "E";
          } else if (windD > 130 && windD < 159) {
            direction = "SE";
          } else if (windD > 160 && windD < 200) {
            direction = "S";
          } else if (windD > 201 && windD < 240) {
            direction = "SW";
          } else if (windD > 241 && windD < 290) {
            direction = "W";
          } else if (windD > 291 && windD < 339) {
            direction = "NW";
          }
          //console.log(windD);
          var windS = parseInt(weather.currentobservation.Winds);
          if (windS <= 1) {
            windString = "Calm";
          } else {
            windString = direction + " " + windS + " mph winds";
          }
          $("#wind-speed").html(windString);
          $("#new-weather").fadeIn().css("display", "table");
        });
      });
    });
    $("#zip").keypress(function (e) {
      if (e.which == 13) {
        // Enter key pressed
        $("#weather-search").click(); // Trigger search button click event
      }
    });
    $("#change").click(function () {
      $("#new-weather").fadeOut(200);
      $("#zip").focus().val("");
    });
  });
  Drupal.behaviors.farmersLearnMore = {
    attach: function attach(context, settings) {
      // Sets playbook link's tabindex, done using JS since content is in Drupal
      $(".learn-more-farmers__content").children().find("a").attr("tabindex", -1);
      var learnMoreElement = $(".learn-more-farmers .learn-more-farmers__trigger");
      if (learnMoreElement.length > 0) {
        var parentLearnMore = $(learnMoreElement.parents(".learn-more-farmers")[0]);
        var dropdown = parentLearnMore.find(".learn-more-farmers__dropdown");
        var farmersLearnMoreStyles = function farmersLearnMoreStyles(dropdown, hidden) {
          if (hidden === true) {
            dropdown.css("height", "0");
            // Adding 508 controls and tab indexes
            dropdown.children(".learn-more-farmers__content").attr("aria-hidden", true);
            learnMoreElement.attr("aria-expanded", false);
            $(".learn-more-farmers__content").children().find("a").attr("tabindex", -1);
          } else {
            dropdown.css("height", dropdown.children(".learn-more-farmers__content").outerHeight(true) + "px");
            // Adding 508 controls and tab indexes
            dropdown.children(".learn-more-farmers__content").attr("aria-hidden", false);
            learnMoreElement.attr("aria-expanded", true);
            $(".learn-more-farmers__content").children().find("a").attr("tabindex", 0);
          }
        };
        var farmersLearnMore = function farmersLearnMore(target) {
          if (parentLearnMore.hasClass("active")) {
            parentLearnMore.removeClass("active");
            farmersLearnMoreStyles(dropdown, true);
          } else {
            parentLearnMore.addClass("active");
            farmersLearnMoreStyles(dropdown, false);
          }
        };
        $(window).resize(function () {
          if (parentLearnMore.hasClass("active")) {
            farmersLearnMoreStyles(dropdown, false);
          }
        });
        learnMoreElement.once("farmersLearnMore").on("click", function (event) {
          farmersLearnMore(event.currentTarget);
        });
      }
    }
  };
  Drupal.behaviors.TranslatedResources = {
    attach: function attach(context, settings) {
      $(document).ajaxSend(function (event, jqxhr, settings) {
        var _settings$extraData, _settings$extraData2;
        if ((settings === null || settings === void 0 || (_settings$extraData = settings.extraData) === null || _settings$extraData === void 0 ? void 0 : _settings$extraData.view_name) !== undefined && (settings === null || settings === void 0 || (_settings$extraData2 = settings.extraData) === null || _settings$extraData2 === void 0 ? void 0 : _settings$extraData2.view_display_id) !== undefined) {
          var _settings$extraData3, _settings$extraData4;
          if ((settings === null || settings === void 0 || (_settings$extraData3 = settings.extraData) === null || _settings$extraData3 === void 0 ? void 0 : _settings$extraData3.view_name) == 'multilingual_library' && (settings === null || settings === void 0 || (_settings$extraData4 = settings.extraData) === null || _settings$extraData4 === void 0 ? void 0 : _settings$extraData4.view_display_id) == 'default') {
            var language_primary = $('[data-shs-level="0"] select').val();
            var language_secondary = $('[data-shs-level="1"] select').val();
            if (drupalSettings.hasOwnProperty('language_name')) {
              var languageList = drupalSettings.language_name;
            }
            language_primary = Object.keys(languageList)[Object.values(languageList).indexOf(language_primary)];
            language_secondary = Object.keys(languageList)[Object.values(languageList).indexOf(language_secondary)];
            if (language_secondary) {
              var language = language_secondary;
            } else if (language_primary) {
              var language = language_primary;
            } else {
              var language = '';
            }
            var updatedUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?language=' + encodeURIComponent(language);
            window.history.pushState({
              path: updatedUrl
            }, '', updatedUrl);
          }
        }
      });
      $(document).ajaxComplete(function (event, xhr, settings) {
        //if((settings?.extraData?.view_name !== undefined) && (settings?.extraData?.view_display_id !== undefined)) {
        //if((settings?.extraData?.view_name == 'multilingual_library') && (settings?.extraData?.view_display_id == 'default')) {
        var ssh_1 = $('[data-shs-level="1"]').length;
        $('[data-shs-level="0"]').find('option[value="All"]').text('Please Select');
        $('[data-shs-level="0"]').find('label').text('Language').removeClass('visually-hidden');
        $('[data-shs-level="0"]').parents('.form-item').children('label').hide();
        if (!ssh_1) {
          var ssh = $('[data-shs-level="0"]').clone();
          var ssh = '<div class="shs-widget-container" data-shs-level="1"><label id="edit-field-tags-target-id-shs-0-1-label" class="">Category</label><select id="edit-field-tags-target-id-shs-0-1" aria-labelledby="edit-field-tags-target-id-shs-0-1-label" class="shs-select form-select form-element form-element--type-select" style="" disabled><option value="All" class="has-children">Please Select</option></select></div>';
          $('[data-shs-level="0"]').after(ssh);
        }
        $('.shs-widget-container').each(function () {
          $(this).find('select option[value="All"]').text('Please Select');
        });
        $('[data-shs-level="1"] label').text("Category").removeClass('visually-hidden');
        if ($('[data-shs-level="1"] select option').length == 1) {
          $('[data-shs-level="1"] select').prepend('<option vaues="All">Please Select</option>');
          $('[data-shs-level="1"] select').prop('selectedIndex', 1);
        }
        // }
        // }
      });
    }
  };
  document.addEventListener("DOMContentLoaded", function () {
    var defaultFirstSelectLabelSelector = ".form-item-term-node-tid-depth-- > label";
    var selectFirstSelector = ".shs-field-container--- > .shs-widget-container:nth-child(1) > select";
    var selectSecondSelector = ".shs-field-container-- > .shs-widget-container:nth-child(2) > select";
    var labelFirstSelector = ".shs-field-container--- > .shs-widget-container:nth-child(1) > label";
    var labelSecondSelector = ".shs-field-container-- > .shs-widget-container:nth-child(2) > label";

    /*
    function addPleaseSelect(selectElement) {
    // Check if the option with value "PleaseSelect" already exists
    const existingOption = Array.from(selectElement.options).find((option) => option.value === "PleaseSelect");
    	// Remove the existing "Please Select" option if it exists
    if (existingOption) {
    selectElement.removeChild(existingOption);
    }
    	// Create and insert the "Please Select" option dynamically
    const pleaseSelectOption = document.createElement("option");
    pleaseSelectOption.value = "PleaseSelect";
    pleaseSelectOption.textContent = "Please Select";
    pleaseSelectOption.disabled = true;
    pleaseSelectOption.selected = true;
    selectElement.insertBefore(pleaseSelectOption, selectElement.firstChild);
    }
    	const changeLabel = (labelText = "Keywords", labelElem = document.querySelector(labelSecondSelector)) => {
    labelElem.innerText = labelText;
    labelElem.classList.remove("visually-hidden");
    labelElem.classList.add('position-relative');		
    };
    		function simulateDropdownSelection(firstDropdown, value) {
    // Set the value of the dropdown
    firstDropdown.value = value;
    	// Create a change event
    const event = new Event("change", { bubbles: true });
    	// Manually dispatch the change event on the dropdown
    firstDropdown.dispatchEvent(event);
    	// Find the option element corresponding to the value
    const optionToClick = firstDropdown.querySelector(`option[value="${value}"]`);
    	// Simulate a click on the option to ensure it's activated visually
    optionToClick.click();
    }
    	function appendHtmlToElement(selector, htmlContent) {
    const container = document.querySelector(selector);
    	// Create a new div element
    const newElement = document.createElement("div");
    	// Set the inner HTML of the new element to the provided HTML content
    newElement.innerHTML = htmlContent;
    	// Append the new element as a child of the container
    if (!document.querySelector(".dummy-select")) {
    container.appendChild(newElement);
    }
    }
    	const script = document.createElement("script");
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/arrive/2.4.1/arrive.min.js";
    script.onload = function () {
    simulateDropdownSelection(document.querySelector(selectFirstSelector), "14835");
    document.querySelector(selectFirstSelector).value = "All";
    document.arrive(labelSecondSelector, function (labelElem) {
    changeLabel();
    const firstSelect = document.querySelector(selectFirstSelector);
    if (firstSelect.value === "All" || firstSelect.value === "PleaseSelect") {
    document.querySelector(selectSecondSelector).disabled = true;
    } else {
    document.querySelector(selectSecondSelector).disabled = false;
    }
    });
    	document.querySelector(defaultFirstSelectLabelSelector).classList.add("visually-hidden");
    changeLabel("Language", document.querySelector(labelFirstSelector));
    	document.arrive(selectFirstSelector, function (firstSelect) {
    document.querySelector(defaultFirstSelectLabelSelector).classList.add("visually-hidden");
    changeLabel("Language", document.querySelector(labelFirstSelector));
    	const secondSelectFunction = () => {
    if (firstSelect.value === "All") {
    appendHtmlToElement(".shs-field-container", `<div class="shs-widget-container dummy-select" data-shs-level="1"><label id="edit-term-node-tid-depth-shs-0-1-label" class="">Keywords</label><select aria-labelledby="edit-term-node-tid-depth-shs-0-1-label" class="shs-select form-select form-element form-element--type-select" style="" disabled="" ><option value="All">- Any -</option></select></div>`);
    }
    document.arrive(selectSecondSelector, { onceOnly: true }, function (secondSelect) {
    if (firstSelect.value === "All") {
    secondSelect.disabled = true;
    } else {
    secondSelect.disabled = false;
    }
    	addPleaseSelect(secondSelect);
    changeLabel();
    function checkSelectedOption() {
    if (secondSelect.value === "All" || secondSelect.value === "PleaseSelect") {
    secondSelect.classList.add("disabled-select");
    } else {
    secondSelect.classList.remove("disabled-select");
    }
    changeLabel();
    }
    // Attach the change event listener to the select element
    secondSelect.addEventListener("change", checkSelectedOption);
    	// Initial check in case "All" is the default selected option
    checkSelectedOption();
    });
    };
    firstSelect.addEventListener("change", secondSelectFunction);
    secondSelectFunction();
    });
    };
    document.head.appendChild(script);
    */
    // Dynamically inject CSS styles
    var style = document.createElement("style");
    style.textContent = "\n\t\t/* Mobile */\n\t\t.shs-widget-container{display:block}\n\t\t.bef-exposed-form .form--inline .form-item{margin-bottom:10px}\n\t\t.shs-field-container .shs-widget-container{width:100%}\n\t\t.shs-field-container{display:flex;flex-direction:column;gap:1em}\n\t\t.bef-exposed-form .form--inline .form-item{margin-bottom:8px}\n\t\t@media screen and (max-width: 769px) {\n\t\t.view-multilingual-library .form--inline{grid-template-rows: repeat(1, 1fr)}\n\t\t.view-multilingual-library .form-actions.form-wrapper{margin-top:0.5em}\n\t\t}\n\n\t\t/* PC / TABLET */\n\t\t@media (min-width: 768px) {\n\t\t  .shs-field-container{flex-direction:row;gap:0.5em}\n\t\t  .shs-field-container .shs-widget-container{min-width: 250px}\n\t\t  .view-multilingual-library .form--inline{grid-template-columns: repeat(auto-fill, 510px);align-items: center;gap:0.5em}\n\t\t  .view-multilingual-library .js-form-type-textfield{margin-right:0; margin-top: -2px}\n\t\t  .view-multilingual-library .form-actions.form-wrapper{margin-top:12px}\n\t\t  .view-multilingual-library .form-actions.form-wrapper{display:contents}\n\t\t  .view-multilingual-library .form-actions.form-wrapper input{max-width:100px}\n\t\t  .bef-exposed-form .form--inline .form-item{margin-bottom:10px}\n\t\t}\n\t\t";
    document.head.appendChild(style);
  });

  // Function to animate collapsing of section
  function collapseRow(row) {
    var height = row.scrollHeight;
    var duration = 300; // milliseconds
    var interval = 1000 / 60; // 60fps

    var start = null;
    function animate(timestamp) {
      if (!start) start = timestamp;
      var progress = timestamp - start;
      row.style.height = height - progress / duration * height + 'px';
      if (progress < duration) {
        requestAnimationFrame(animate);
      } else {
        row.style.display = 'none';
        row.remove();
      }
    }
    requestAnimationFrame(animate);
  }

  // 508 Compliance Navigation

  document.body.onkeydown = function (e) {
    e = e || window.event; // Normalize the event for IE
    var target = e.srcElement || e.target; // Get the element that event was triggered on
    var tagName = target.tagName; // get the tag name of the element
    var excludeTags = ["textarea", "input", "select"];
    if (tagName.toLowerCase() === "body") return true;
    if (!excludeTags.includes(tagName.toLowerCase())) return !(e.keyCode === 32);
  };
  document.body.onkeyup = function (e) {
    e = e || window.event; // Normalize the event for IE
    var target = e.srcElement || e.target; // Get the element that event was triggered on
    if (e.keyCode === 32) {
      if (target.tagName.toLowerCase() === "a" || target.tagName.toLowerCase() === "button" || target.classList.contains("accordion") || target.classList.contains("card") || target.classList.contains("learn-more-farmers__trigger") || target.classList.contains("close")) {
        e.preventDefault();
        target.click();
      }
    }
  };

  // needed to add this for the MFP form privacy act disclaimer to work correctly
  var learnMoreElement = $(".mfp-learn-more-farmers .mfp-learn-more-farmers__trigger");
  if (learnMoreElement.length > 0) {
    var parentLearnMore = $(learnMoreElement.parents(".mfp-learn-more-farmers")[0]);
    var dropdown = parentLearnMore.find(".mfp-learn-more-farmers__dropdown");
    var farmersLearnMoreStyles = function farmersLearnMoreStyles(dropdown, hidden) {
      if (hidden === true) {
        dropdown.css("height", "0");
        // Adding 508 controls and tab indexes
        dropdown.children(".mfp-learn-more-farmers__content").attr("aria-hidden", true);
        learnMoreElement.attr("aria-expanded", false);
        $(".mfp-learn-more-farmers__content").children().find("a").attr("tabindex", -1);
      } else {
        dropdown.css("height", dropdown.children(".mfp-learn-more-farmers__content").outerHeight(true) + "px");
        // Adding 508 controls and tab indexes
        dropdown.children(".mfp-learn-more-farmers__content").attr("aria-hidden", false);
        learnMoreElement.attr("aria-expanded", true);
        $(".mfp-learn-more-farmers__content").children().find("a").attr("tabindex", 0);
      }
    };
    var farmersLearnMore = function farmersLearnMore(target) {
      if (parentLearnMore.hasClass("active")) {
        parentLearnMore.removeClass("active");
        farmersLearnMoreStyles(dropdown, true);
      } else {
        parentLearnMore.addClass("active");
        farmersLearnMoreStyles(dropdown, false);
      }
    };
    $(window).resize(function () {
      if (parentLearnMore.hasClass("active")) {
        farmersLearnMoreStyles(dropdown, false);
      }
    });
    learnMoreElement.on("click", function (event) {
      farmersLearnMore(event.currentTarget);
    });
  }
  var stringTrimmer = function stringTrimmer(node) {
    var string = node.text();
    var newString = string.split("_").join("");
    node.text(newString);
  };
  if ($("#block-farmers-ccc-910-webform").length) {
    $("#edit-actions").prepend('<hr style="border-top: dotted 1px;">');
    // setting the styling for the button and apply text that should only appear in step 1
    setInterval(function () {
      if ($("li.progress-step")[0].classList.contains("is-active")) {
        $("#edit-actions-wizard-next").css("float", "none");
        $(".apply-text").removeClass("hidden");
      } else {
        $("#edit-actions-wizard-next").css("float", "right");
        $(".apply-text").addClass("hidden");
        $(".step-1-header").addClass("hidden");
      }
      // all of this to disable the next button if nothing is selected
      if ($("li.progress-step")[1].classList.contains("is-active")) {
        if ($("#edit-crops-checks-corn").prop("checked") || $("#edit-crops-checks-cotton").prop("checked") || $("#edit-crops-checks-sorghum").prop("checked") || $("#edit-crops-checks-soybeans").prop("checked") || $("#edit-crops-checks-wheat").prop("checked") || $("#edit-livestock-related-checks-dairy").prop("checked") || $("#edit-livestock-related-checks-hogs").prop("checked") || $("#edit-crops-checks-shelled-almonds").prop("checked") || $("#edit-crops-checks-fresh-sweet-cherries").prop("checked")) {
          $("#edit-actions-wizard-next").prop("disabled", false);
        } else if (!$("#edit-crops-checks-corn").prop("checked") || !$("#edit-crops-checks-cotton").prop("checked") || !$("#edit-crops-checks-sorghum").prop("checked") || !$("#edit-crops-checks-soybeans").prop("checked") || !$("#edit-crops-checks-wheat").prop("checked") || !$("#edit-livestock-related-checks-dairy").prop("checked") || !$("#edit-livestock-related-checks-hogs").prop("checked") || !$("#edit-crops-checks-shelled-almonds").prop("checked") || !$("#edit-crops-checks-fresh-sweet-cherries").prop("checked")) {
          $("#edit-actions-wizard-next").prop("disabled", true);
        }
        $(".step-2-header").removeClass("hidden");
      } else {
        $(".step-2-header").addClass("hidden");
      }
      if ($('li[data-webform-page="production_information"]')[0].classList.contains("is-active")) {
        $(".step-3-header").removeClass("hidden");
      } else {
        $(".step-3-header").addClass("hidden");
      }
    }, 200);
    if ($('li[data-webform-page="production_information"]')[0].classList.contains("is-active") && $(".js-form-item-cwt-dairy").length) {
      $('label[for="edit-cwt-dairy"]').append('<a class="tooltip-link" data-tooltip="hundredweight" tabindex="0">i</a>');
    }
    // if we're on the confirmation step of the webform
    if ($(".webform-confirmation").length) {
      $("#initial-step-stepper").addClass("hidden");
      $("#final-step-stepper").removeClass("hidden");
      $(".step-4-header").removeClass("hidden");
      // remove the underscores
      stringTrimmer($(".corn-bushels"));
      stringTrimmer($(".cotton-bushels"));
      stringTrimmer($(".sorghum-bushels"));
      stringTrimmer($(".soybean-bushels"));
      stringTrimmer($(".wheat-bushels"));
      stringTrimmer($(".shelled-almonds-pounds"));
      stringTrimmer($(".fresh-sweet-cherries-pounds"));
      stringTrimmer($(".dairy-cwt"));
      stringTrimmer($(".hog-head"));
      // if these fields dont contain a number, hide them
      if (!$(".corn-bushels").text().match(/\d/)) {
        $(".corn-bushels").addClass("hidden");
      }
      if (!$(".cotton-bushels").text().match(/\d/)) {
        $(".cotton-bushels").addClass("hidden");
      }
      if (!$(".sorghum-bushels").text().match(/\d/)) {
        $(".sorghum-bushels").addClass("hidden");
      }
      if (!$(".soybean-bushels").text().match(/\d/)) {
        $(".soybean-bushels").addClass("hidden");
      }
      if (!$(".wheat-bushels").text().match(/\d/)) {
        $(".wheat-bushels").addClass("hidden");
      }
      if (!$(".shelled-almonds-pounds").text().match(/\d/)) {
        $(".shelled-almonds-pounds").addClass("hidden");
      }
      if (!$(".fresh-sweet-cherries-pounds").text().match(/\d/)) {
        $(".fresh-sweet-cherries-pounds").addClass("hidden");
      }
      if (!$(".dairy-cwt").text().match(/\d/)) {
        $(".dairy-cwt").addClass("hidden");
      }
      if (!$(".hog-head").text().match(/\d/)) {
        $(".hog-head").addClass("hidden");
      }
    } else {
      $(".step-4-header").addClass("hidden");
    }

    //MFP form auto-filling fields
    $('label[for="edit-same-as-producer-name"]').on("click", function () {
      if ($(this).hasClass("checked")) {
        $(this).removeClass("checked");
        $("#edit-first-name-contact").val("").focus();
        $("#edit-middle-name-contact").val("").focus();
        $("#edit-last-name-contact").val("").focus();
      } else {
        $(this).addClass("checked");
        $("#edit-first-name-contact").val($("#edit-first-name").val()).focus();
        $("#edit-middle-name-contact").val($("#edit-middle-name").val()).focus();
        $("#edit-last-name-contact").val($("#edit-last-name").val()).focus();
      }
    });
    $("#edit-who-is-this-an-entity").on("click", function () {
      if ($("#edit-middle-name").val() !== "" || $("#edit-last-name").val() !== "") {
        $("#edit-middle-name").val("");
        $("#edit-last-name").val("");
      }
    });
    $(".js-form-type-checkbox").on("click", function () {
      if ($(this).prop("checked")) {
        $(this).prop("checked", false);
      } else {
        $(this).prop("checked", true);
      }
    });
  }
  $(document).ready(function () {
    var card_carousel_element = document.querySelector(".card-carousel");

    // Remove slides from direct tab oder to fix issue: #4880
    // Add carousel bullets back into tab order, undoing a previous fix
    // Slides can still be accesed using prev/next buttons by mouse or keyboard
    var card_carouse_slide_bullets = document.querySelectorAll('.blog-stories-dots button.glide__bullet');
    card_carouse_slide_bullets.forEach(function (anchor) {
      anchor.tabIndex = 0;
    });
    if (!!card_carousel_element) {
      // const card_carousel = new Glider( card_carousel_element, {
      // 	draggable: true,
      // 	scrollLock: true,
      // 	scrollLockDelay: 25,
      // 	scrollPropagate: false,
      // 	duration: 1,
      // 	rewind: true,
      // 	arrows: {
      // 		prev: '.card-carousel-prev.glide-arrow',
      // 		next: '.card-carousel-next.glide-arrow'
      // 	}
      // });
      // card_carousel.refresh();
    }
    var image_carousel_elements = document.querySelectorAll(".image-carousel");
    if (!!image_carousel_elements) initiateCarousel(image_carousel_elements, {
      type: "carousel",
      startAt: 0,
      animationDuration: 800,
      gap: 30
    });
    function initiateCarousel(elements, options) {
      for (var i = 0; i < elements.length; i++) {
        var glide = new Glide(elements[i], options);
        glide.mount();
      }
    }
    function to_position(divid) {
      $("html, body").animate({
        scrollTop: $(divid).offset().top
      }, "slow");
    }
    $(".anchor-link-target").on("keypress click", function (event) {
      if (event.type === "keypress" && event.keyCode !== 13) return;
      var anchor = $(this).data("anchor");
      if ($(this).data("accordion") === "") {
        $(".accordion.active").click();
        setTimeout(function () {
          to_position(anchor);
          $(anchor).click();
        }, 400);
      } else {
        to_position(anchor);
      }
    });
    var isMobile = false; //initiate as false
    // device detection
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
      isMobile = true;
    }
    var is_iPad = navigator.userAgent.match(/iPad/i) != null;

    // ============================================

    // adding aria-labels to sevice center locator
    $(".simpler-select.form-select.simpler-select-root").eq(0).attr({
      label: "Select a State",
      "aria-label": "Select a State"
    });
    $(".simpler-select.form-select.simpler-select-root").eq(0).change(function () {
      $(".simpler-select.form-select.simpler-select-root").eq(1).attr({
        label: "Select a County",
        "aria-label": "Select a County"
      });
    });
    if (is_iPad && Math.abs(window.orientation) === 90 || !isMobile) {
      $(".usa-nav-submenu > li > a").click(function (e) {
        if ($(this).parent().find(".usa-nav-submenu-submenu").length > 0) {
          e.preventDefault();
          e.stopPropagation();
          $(".usa-nav-submenu-submenu").hide();
          $(".submenu-item-active").removeClass("submenu-item-active");
          $(this).parent().find(".usa-nav-submenu-submenu").toggle();
          $(this).toggleClass("submenu-item-active");
        }
      });
      $(".usa-accordion-button.usa-nav-link").click(function () {
        $(".submenu-item-active").removeClass("submenu-item-active");
        $(".usa-nav-submenu-submenu:visible").hide();
      });
    }
  });

  // For video thumbnails on /conserve/soil-health
  var videoThumbLinks = _toConsumableArray(document.querySelectorAll(".video-thumb > a"));
  if (videoThumbLinks) {
    videoThumbLinks.map(function (link) {
      link.addEventListener("keydown", function (evt) {
        if (evt.keyCode === 13 || evt.keyCode === 32) evt.stopPropagation();
        if (evt.keyCode === 32) evt.preventDefault();
      });
    });
  }
  $(document).ready(function () {
    setMobileAccordions();
    browserSpecificAlerts();
    addTabIndexToElements(document.querySelectorAll(".category-slide"));
    convertDesignSystemExternalLinks(document.querySelectorAll(".resource-card .link a"));
    convertDesignSystemExternalLinks(document.querySelectorAll(".national-programs-deadline-home-block .text-link"));
    convertDesignSystemExternalLinks(document.querySelectorAll(".national-programs-deadline-page-ongoing .text-link"));
    convertDesignSystemExternalLinks(document.querySelectorAll(".national-programs-deadline-page-past .text-link"));

    // change flex direction on .field-content if it has
    // grid classes
    var fieldContent = document.querySelectorAll(".field-content .row");
    if (fieldContent) {
      fieldContent.forEach(function (row) {
        var gridClass = row.querySelectorAll('[class*="usa-width-"]');
        if (gridClass.length) {
          row.style.flexDirection = "row";
        }
      });
    }

    // convert images on prepare step card to use circles.
    // TODO: cannot change right now as content is in DB. Look into this once new theme is launched.
    var prepareSteps = document.querySelectorAll(".prepare_steps");
    if (prepareSteps) {
      prepareSteps.forEach(function (step) {
        var prepareImages = step.querySelectorAll(".checkbox");
        if (prepareImages) {
          prepareImages.forEach(function (image) {
            image.outerHTML = '<div class="circle-check"></div>';
          });
        }
      });
    }
  });
  window.onresize = function () {
    // storing window width for reference later as mobile devices
    // trigger resize event on scroll
    localStorage.setItem("window_width", window.innerWidth);
    setMobileAccordions();
  };

  // hidden until found
  window.addEventListener("load", function (event) {
    document.querySelectorAll(".card-accordion").forEach(function (accordion) {
      accordion.onbeforematch = function () {
        accordion.classList.add("show");
        var toggle = accordion.querySelector(".card-accordion-toggle .card-accordion-show-more");
        toggle.innerHTML = "Show Less";
        toggle.classList.remove("card-accordion-show-more");
        toggle.classList.add("card-accordion-show-less");
      };
    });
  });
  function setMobileAccordions() {
    var mobile_accordions = document.querySelectorAll(".mobile-accordion");
    if (mobile_accordions) {
      mobile_accordions.forEach(function (accordion) {
        var trigger = accordion.querySelector(".Accordion-trigger");
        var panel = accordion.querySelector(".Accordion-panel");
        var pointerEvent = getComputedStyle(trigger, null).pointerEvents;

        // need to check that the window width hasn't changed because
        // mobile devices trigger resize events on scroll
        if (pointerEvent === "auto" && window.innerWidth !== Number(localStorage.getItem("window_width"))) {
          panel.setAttribute("hidden", "");
          accordion.removeEventListener("click", stopAccordionScroll);
        }
        if (pointerEvent !== "auto") {
          panel.removeAttribute("hidden", "");
          accordion.addEventListener("click", stopAccordionScroll);
        }
      });
    }
  }
  function stopAccordionScroll(event) {
    event.stopPropagation();
  }
  function convertDesignSystemExternalLinks(links) {
    if (links) {
      links.forEach(function (link) {
        var external = link.querySelector("svg.ext");
        if (external) {
          link.classList.remove("text-link");
          link.classList.add("external-link");
          external.style.display = "none";
        }
      });
    }
  }
  function addTabIndexToElements(elements) {
    // this is used when we can't modify a twig template (such as core theme files)
    if (elements) {
      elements.forEach(function (element) {
        element.tabIndex = "0";
      });
    }
  }

  // conservation at work videos
  var cawFormClass = ".caw-allvideos-page-01";
  var cawElement = document.querySelector(cawFormClass);

  // if (cawElement) {
  // 	let observer = new MutationObserver(cawMobileButtonEvents);
  // 	observer.observe(cawElement, {
  // 		attributes: true,
  // 		childList: true,
  // 		subtree: true,
  // 	});
  if (cawElement) {
    cawInit();
    document.querySelector("#filters-close").addEventListener("click", scrollToCawResults);
    $(document).ajaxComplete(function (event) {
      cawInit();
      document.querySelector("body").classList.remove("no-scroll");
      element_utils.moveCawDropdown();
      scrollToCawResults();
      setCloseButtonEvent(cawFormClass);
    });
  }
  function setCloseButtonEvent(cawFormClass) {
    // have to keep resetting this or it gets removed after a few Ajax calls
    document.querySelector("".concat(cawFormClass, " #filters-close")).removeEventListener("click", scrollToCawResults);
    document.querySelector("".concat(cawFormClass, " #filters-close")).addEventListener("click", scrollToCawResults);
  }
  function scrollToCawResults() {
    var top = document.querySelector(".display-count").getBoundingClientRect().y;
    setTimeout(function () {
      window.scrollBy({
        top: top,
        left: 0,
        behavior: "smooth"
      });
    }, 250);
  }
  function setMobileCawSelections() {
    var selectedTerms = document.querySelectorAll("[id*=\"edit-field-caw-tags-target-id\"] input[type=\"checkbox\"]:checked");
    // check mobile filter inputs
    selectedTerms.forEach(function (row) {
      document.querySelector(".view-conservation-at-work-mobile-filters input[value=\"".concat(row.value, "\"]")).checked = true;
    });
  }
  function cawInit() {
    window.addEventListener("DOMContentLoaded", function () {
      //reset all fields - fixes Firefox bug
      var typeDropdown = document.querySelector("[id*='edit-field-caw-tags-target-id']");
      var titleField = document.querySelector("#edit-title");
      var descriptionField = document.querySelector("#edit-field-caw-description-value");
      var sortByDropdown = document.querySelector("#edit-sort-by");
      if (!!typeDropdown) typeDropdown.value = "All";
      if (!!titleField) titleField.value = "";
      if (!!descriptionField) descriptionField.value = "";
      if (!!sortByDropdown) sortByDropdown.value = "published_at";
    });
    $(document).ready(function () {
      // cawMobileButtonEvents();
      cawFormEvents();
      // setMobileCawSelections();
    });
  }
  function submitForm() {
    setTimeout(function () {
      document.querySelector("[id*='edit-submit-conservation-at-work-videos']").click();
    }, 250);
  }
  function cawFormEvents() {
    $(document).ready(function () {
      $("#views-exposed-form-conservation-at-work-videos-caw-allvideos-page-01 label").on("click keypress", function (event) {
        if (event.keyCode && event.keyCode !== 32) return;
        submitForm();
      });
      $("[id*='edit-sort-by']").on("change", function (event) {
        event.preventDefault();
        event.stopPropagation();
        submitForm();
      });
      $("[id*='edit-reset']").on("click", function (event) {
        event.preventDefault();
        location.reload();
      });
    });
  }
  function cawMobileButtonEvents(mutations) {
    $(document).ready(function () {
      var mobileButton = document.querySelector(".caw-video-submit-mobile");
      if (!!mobileButton) {
        mobileButton.addEventListener("click", function (evt) {
          var allInputs = document.querySelectorAll('[id*="edit-field-caw-tags-target-id"] input');
          var selectedTerms = document.querySelectorAll("label[for*=\"caw-mobile-edit\"] input:checked");
          allInputs.forEach(function (row) {
            row.checked = false;
          });
          selectedTerms.forEach(function (row) {
            var checkbox = document.querySelector("[id*='edit-field-caw-tags-target-id-".concat(row.value, "'"));
            if (!!checkbox) checkbox.checked = true;
          });
          document.querySelector(".views-exposed-form input[type=submit]").click();
        });
      }
    });
  }
  function browserSpecificAlerts() {
    var alertClass = ".browser-specific-alert";
    var browserSpecific = document.querySelectorAll(alertClass);
    var browsers = ["edge", "edge-legacy", "chrome", "firefox", "safari"];
    if (browserSpecific) {
      browserSpecific.forEach(function (element) {
        var showAlert = false;
        element.classList.forEach(function (className) {
          if (navigator.userAgent.indexOf("Edge/") > 0 && className === "edge-legacy") {
            showAlert = true;
          }
          if (navigator.userAgent.indexOf("Edg/") > 0 && className === "edge") {
            showAlert = true;
          }
          if (document.querySelector("html.".concat(className)) && browsers.includes(className) && className !== alertClass && className !== "edge" && className !== "edge-legacy") {
            showAlert = true;
          }
          if (showAlert) element.style.display = "block";
        });
      });
    }
  }
  function addSrcToLazyLoadImages(images) {
    images.forEach(function (image) {
      var printImage = image.cloneNode(true);
      image.removeAttribute("loading");
      image.classList.remove("lazyload");
      image.src = image.getAttribute("data-src") ? image.getAttribute("data-src") : image.src;
    });
  }
  window.addEventListener("beforeprint", function (event) {
    var mainImages = document.querySelectorAll("main img");
    var h2aImages = document.querySelectorAll(".temp-ag-workers-lower-wrap img");
    addSrcToLazyLoadImages(mainImages);
    addSrcToLazyLoadImages(h2aImages);
    var allLinks = document.querySelectorAll("main a");
    allLinks.forEach(function (link) {
      var href = link.getAttribute("href");
      if (link.href.indexOf("mailto:") !== -1 && link.innerHTML.indexOf("@") === -1) {
        !link.hasAttribute("class") ? link.setAttribute("class", "show-email") : link.classList.add("show-email");
      }
      if (!!href && href.startsWith("/")) {
        var url = window.location.href.split("/");
        var siteURL = url[0] + "//" + url[2];
        if (siteURL.endsWith("/")) siteURL.substr(0, siteURL.length - 1), _readOnlyError("siteURL");
        link.href = "".concat(siteURL).concat(href);
      }
    });
  });
})(jQuery, Drupal);

},{"./_utils/_caw_utils":3,"./_utils/_element-utils":4,"./_utils/_multilingual_utils":5,"./_utils/_site_banner_utils":6,"./ds-legacy/_ds-legacy":8,"./farmers_blog":12}],12:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fgBlogs = fgBlogs;
var general_utils = _interopRequireWildcard(require("../farmers-gov-design-system/js/_utils/general_utils"));
var blog_utils = _interopRequireWildcard(require("./_utils/blog/_blog_utils"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function fgBlogs($, Drupal) {
  Drupal.behaviors.usda = {
    attach: function attach(context, settings) {
      // send load event to re-render mobile accordions so they will open again after submit
      // *************************************
      // Set variable 'isMobile' for if mobile
      // *************************************
      var isMobile = false; //initiate as false
      // device detection
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|ptermid\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
        isMobile = true;
      }

      // filters
      blog_utils.updateFormInputsFromUrlParams();
      blog_utils.blogFiltersSetNumberOfSelections();

      // *************************************
      //

      // *************************************
      //
      // Mobile video carousel text and controls
      $(document).ready(function () {
        var slickActive = $("#video-carousel-wrap .glide__bullets .glide__bullet--active").attr("aria-label");
        $("#video-carousel-wrap").append('<div id="mobile-video-slick"><button class="mobile-vid-prev" aria-label="Previous" type="button" tabindex="0" style="">Previous</button><div class="slide-count">' + slickActive + ' </div><button class="mobile-vid-next" aria-label="Next" type="button" tabindex="0" style="">Next</button></div>');
        $("#video-carousel-wrap #mobile-video-slick .mobile-vid-prev").click(function () {
          $("#video-carousel-wrap .video-carousel-prev").click();
        });
        $("#video-carousel-wrap #mobile-video-slick .mobile-vid-next").click(function () {
          $("#video-carousel-wrap .video-carousel-next").click();
        });
        $(".connect-blog-tags .views-row").click(function (evt) {
          $(evt.target).find("a").trigger("click");
        });
      });

      // Appending visible desktop filters to the mobile filter accordion areas (might see if we can do this a better way)
      $("#state-filters").append($(".view-state-mobile-filters").not(".view-id-state_mobile_filters").clone());
      $("#commodity-filters").append($(".view-commodity-mobile-filters").clone());
      $("#producer-filters").append($(".view-producer-mobile-filters").clone());
      $(document).ready(function () {
        removeMobileFlagFromElement(document.querySelectorAll("#mobile-filters input"));
        removeMobileFlagFromElement(document.querySelectorAll("#mobile-filters label"));
      });
      function removeMobileFlagFromElement(element) {
        element.forEach(function (row) {
          if (!!row.htmlFor) {
            row.htmlFor = row.htmlFor.replace("term-", "mobile-");
          }
          if (!!row.id) row.id = row.id.replace("term-", "mobile-");
        });
      }

      // Mobile filter slide out and close functionality
      $("#filters-open, #filters-close").keyup(function (e) {
        if (e.key.toLowerCase() === "enter") toggleMobileFilterMenu();
      });
      $("#filters-open, #filters-close").click(function (e) {
        toggleMobileFilterMenu();
      });
      function toggleMobileFilterMenu() {
        $("body").toggleClass("no-scroll");
        $("#filters-open").toggleClass("active");
        $(".mobile-filters").toggleClass("active");

        // views-exposed-form bef-exposed-form usa-form caw-all-videos-form
        if ($("#filters-open").hasClass("active")) {
          $(".mobile-filters").animate({
            right: "100%",
            left: "0"
          });
        } else {
          $(".mobile-filters").animate({
            right: "0",
            left: "100%"
          });
        }

        // for CAW mobile panel (these ended up using the same code)
        if (document.querySelector(".caw-all-videos-form")) {
          $(".caw-all-videos-form .form--inline").toggleClass("active");
          if ($(".filters-caw").hasClass("active")) {
            $(".caw-all-videos-form .form--inline").animate({
              right: "100%",
              left: "0"
            });
          } else {
            $(".caw-all-videos-form .form--inline").animate({
              right: "0",
              left: "100%"
            });
          }
        }
      }
      // When selecting the checkbox filters, this checks the corresponding actual blog hidden filters
      $("#visible-filters label input").on("click", function () {
        var termID = $(this).parent().attr("for");
        var termArray = termID.split("-");
        termID = !!termArray[2] ? termArray[2] : "";
        $(this).toggleClass("checked");

        // const checkboxes = $("input[type=checkbox][value=" + termID + "]");
        var inherentFilter = document.querySelector("#inherent-filters select option[value='".concat(termID, "']"));
        inherentFilter.selected = !inherentFilter.selected;
      });

      // Trigger Submission on checkbox/label click (for desktop only)
      $("#visible-filters .view-commodity-mobile-filters label, #visible-filters .view-producer-mobile-filters label").not("#mobile-filters .view-commodity-mobile-filters label, #mobile-filters .view-producer-mobile-filters label").on("click keyup", function (event) {
        if (event.keyCode && event.keyCode !== 32) return;
        setTimeout(function () {
          $(".views-exposed-form input[type=submit]").click();
        }, 800);
      });

      // Mobile state filter dropdown select and apply filters
      $("#visible-filters .view-state-mobile-filters").not("#mobile-filters .view-state-mobile-filters").change(function () {
        var value = $(this).val();
        $("#inherent-filters select[name=state]").find('option[value="' + value + '"]').prop("selected", true);
        $(".views-exposed-form input[type=submit]").click();
      });

      // Click category carousel item and filter blog post. This also adds an 'active' class to carousel item
      $(document).on("click keyup", ".term-slide", function (event) {
        if (event.keyCode && event.keyCode !== 13 && event.keyCode !== 32) return;
        var termid = $(this).data("termid");
        var categoryFilter = document.querySelector("#inherent-filters select option[value='".concat(termid, "']"));
        categoryFilter.selected = !categoryFilter.selected;
        categoryFilter.classList.add("active");
        $(".views-exposed-form input[type=submit]").click();
        $(document).ajaxComplete(function () {
          if ($('input[value="' + termid + '"]').is(":checked")) {
            $("[data-termid='" + termid + "']").toggleClass("active");
          }
        });
      });

      // When mobile 'Apply Filters' button is clicked, do this stuff...
      $("#apply-filters").click(function () {
        // Find hidden filters state dropdown and select the correct state
        $("#mobile-filters select").each(function () {
          var value = $(this).val();
          $(".views-exposed-form select[name=state]").find('option[value="' + value + '"]').prop("selected", true);
        });

        // All filters to be set and then click the submit button after Apply Button is clicked
        setTimeout(function () {
          $(".views-exposed-form input[type=submit]").click();
        }, 800);
      });
      if (window.location.href.indexOf("/blog") === 0) renderAccordions();

      // need to render accordions for blog filters when user loads the page straight into
      // the browser because the events get removed in the detach section below.
      window.onload = function () {
        if (window.location.href.indexOf("/blog") === 0) renderAccordions();
      };
      function renderAccordions() {
        dispatchEvent(new Event("render-accordions"));
      }
      var blogCategoriesMoreLinkContainer = document.querySelector(".connect-blog-categories .js-pager__items.pager");
      var blogCategoriesMoreLink = document.querySelector(".connect-blog-categories .pager__item a");
      if (!!blogCategoriesMoreLinkContainer) {
        blogCategoriesMoreLinkContainer.addEventListener("click", function (event) {
          localStorage.setItem("blog_no_scroll", true);
        });
      }
      if (!!blogCategoriesMoreLink) {
        blogCategoriesMoreLink.addEventListener("click", function (event) {
          localStorage.setItem("blog_no_scroll", true);
        });
      }

      // After Ajax runs, look to see what filters are selected and check the mobile filters
      $(document).ajaxComplete(function (event) {
        blog_utils.setCheckboxesUsingInherentFilters();
        $("body").removeClass("no-scroll");
        $("#mobile-filters .view-state-mobile-filters").val($("#inherent-filters select[name=state]").val());
        $(".view-state-mobile-filters").val($("#inherent-filters select[name=state]").val());
        var filters = [];
        $.each($(".views-exposed-form input[type=checkbox]:checked"), function () {
          filters.push($(this).val());
        });
        var i;
        for (i = 0; i < filters.length; ++i) {
          if ($('input[value="' + filters[i] + '"]').is(":checked")) {
            $('#visible-filters input[type=checkbox][value="' + filters[i] + '"]').attr("checked", "true");
            $('.view-multi-select-blog-category-carousel .term-slide[data-termid="' + filters[i] + '"]').addClass("active");
          }
        }
        // add tabindex
        $.each($(".term-slide"), function () {
          $(this).attr("tabindex", "0");
        });
        var blogCategoriesTop = document.querySelector(".connect-blog-categories");
        if (!!blogCategoriesTop && !localStorage.getItem("blog_no_scroll")) {
          blogCategoriesTop.scrollIntoView({
            behavior: "smooth"
          });
        } else if (localStorage.getItem("blog_no_scroll")) {
          localStorage.removeItem("blog_no_scroll");
        }
        blog_utils.blogFiltersSetNumberOfSelections();
      });

      // If tid param is in the URL, run this code
      if (window.location.href.indexOf("?term=") > -1) {
        var myParam = location.search.split("term=")[1];
        $("[data-termid='" + myParam + "']").toggleClass("active");
        window.onload = function () {
          if (window.location.href.indexOf("?term=") > -1) {
            $("[data-termid='" + myParam + "']").click();
            $(document).ajaxComplete(function () {
              if ($('input[value="' + myParam + '"]').is(":checked")) {
                $("[data-termid='" + myParam + "']").toggleClass("active");
              }
              general_utils.removeUrlParams();
            });
          }
        };

        // If you're coming from another page with the category carousel on it, this removes the tid
        // from the URL so that youcan deselect the category from the filters
        $(".active[data-termid='" + myParam + "']").on("click", function (e) {
          $(this).removeClass("active");
          general_utils.removeUrlParams();
        });
      }

      // adding aria-labels to blog comments
      $(".comment-blog-comment-form").find("#edit-name").attr("aria-label", "Enter Your Name");
      $(".comment-blog-comment-form").find("#edit-field-formatted-comment-0-value").attr("aria-label", "Enter Your Response Here");
      $("h4.tab-title").keydown(function (evt) {
        if (evt.key == " ") {
          $(evt.target).trigger("click");
        }
      });
      if (!!$("#post-count").length) {
        var tag_post_count = $("#post-count").text();
        var title_text = $("#block-farmers-page-title ").clone();
        var title_prefix = $(".title-prefix").clone();
        title_text.append(tag_post_count);
        title_text.prepend(title_prefix);
        $(".view-header").html(title_text);

        // remove original page title for 508 concerns (multiple h1's)
        $(".blog-tags-farmers-page-title").remove();
      }

      // Carousel hack for tag view page
      if (!!$(".connect-blog-tags").length) {
        $(".block.block-views.block-views-blockblog-category-carousel-block-1").find("h2").text("Explore Categories");
        $(".block.block-views.block-views-blockblog-category-carousel-block-1 .view-footer").find("a").hide();
        if (isMobile) {
          $("button.slick-arrow").hide();
          $("#term-carousel").parent().css("zoom", ".8");
          $("#term-carousel").find(".slick-slide").css("margin-right", "1rem");
        }
      }

      // ===========================
      $(document).on("click", "ul[data-drupal-views-infinite-scroll-pager]", function (evt) {
        if (!!$(this).find("li.pager__item").length) {
          $(this).find(".button").click();
        }
      });
      // ===========================

      var overlayThrobber = document.querySelector(".overlay-throbber");
      $(document).ajaxSuccess(function (evt) {
        if (!!overlayThrobber) overlayThrobber.style.display = "none";
      });
      $(document).ajaxStart(function (evt) {
        if (!!overlayThrobber) overlayThrobber.style.display = "flex";
      });

      // This is for removing the right arrow on category carousel on mobile
      if (isMobile) {
        $(".view-blog-category-carousel").find(".slick-arrow.slick-next").hide();
      }
      $(".blog-teaser").click(function () {
        $(this).find("a")[0].click();
      });
    },
    detach: function detach(context, settings, trigger) {
      $("#apply-filters").off();
      $(".term-slide").off();
      $(".Accordion").off();
      $(".Accordion-trigger").off();
    }
  };

  // Provides disabled attribute for the left and right arrows for slider carousels only
  var ArrowDisabler = function ArrowDisabler(Glide, Components, Events) {
    return {
      mount: function mount() {
        // Only in effect when rewinding is disabled
        if (Glide.settings.rewind) {
          return;
        }
        Glide.on(["mount.after", "run"], function () {
          // Filter out arrows_control
          var _iterator = _createForOfIteratorHelper(Components.Controls.items),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var controlItem = _step.value;
              if (controlItem.className !== "glide__arrows") {
                continue;
              }

              // Set left arrow state
              var left = controlItem.querySelector(".glide__arrow--left");
              if (left) {
                if (Glide.index === 0) {
                  left.setAttribute("disabled", ""); // Disable on first slide
                } else {
                  left.removeAttribute("disabled"); // Enable on other slides
                }
              }

              // Set right arrow state
              var right = controlItem.querySelector(".glide__arrow--right");
              if (right) {
                if (Glide.index === Components.Sizes.length - Glide.settings.perView) {
                  right.setAttribute("disabled", ""); // Disable on last slide
                } else {
                  right.removeAttribute("disabled"); // Disable on other slides
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });
      }
    };
  };

  // Initiate Carousel functionality. Not all carousels use this function
  function initiateCarousel(elements, options) {
    for (var i = 0; i < elements.length; i++) {
      var glide = new Glide(elements[i], options);
      if (document.getElementById("blog-hero-carousel")) setUpBlogHeroCarouselEvents(glide);
      glide.mount();
      return glide;
    }
  }
  $(document).ready(function () {
    renderCategoryCarousel();
    var listeningElement = document.getElementById("main-content");

    // category carousel
    var category_carousel_element = document.querySelectorAll(".category-carousel");
    if (category_carousel_element.length > 0) {
      category_carousel_element.forEach(function (row) {
        renderCategoryCarousel(row);
      });
    }

    // view category carousel
    if (!!listeningElement) {
      var multi_category_carousel_element = listeningElement.querySelector(".view-multi-select-blog-category-carousel .multi-category-carousel-wrap");
      if (!!multi_category_carousel_element) {
        var multi_category_carousel = new Glide(multi_category_carousel_element);
        multi_category_carousel.mount({
          ArrowDisabler: ArrowDisabler
        });
      }
    }
    $(document).ajaxComplete(function (evt) {
      var category_carousel_element = document.querySelectorAll(".category-carousel");
      if (category_carousel_element.length > 0) {
        category_carousel_element.forEach(function (row) {
          renderCategoryCarousel(row);
        });
      }
    });
    function renderCategoryCarousel(category_carousel_element, options) {
      if (!!category_carousel_element) {
        var category_carousel = new Glide(category_carousel_element, {
          type: "slider",
          startAt: 0,
          perView: 5,
          bound: true,
          animationDuration: 500,
          animationTimingFunc: "linear",
          keyboard: true,
          rewind: false,
          breakpoints: {
            1079: {
              startAt: 0,
              perView: 4,
              focusAt: 0,
              peek: {
                before: 15,
                after: 50
              }
            },
            768: {
              startAt: 0,
              perView: 3,
              focusAt: 0,
              peek: {
                before: 15,
                after: 50
              }
            },
            600: {
              startAt: 0,
              perView: 1,
              focusAt: 0,
              peek: {
                before: 15,
                after: 50
              }
            }
          }
        });
        category_carousel.mount({
          ArrowDisabler: ArrowDisabler
        });
      }
    }
  });
  var blog_carousel_elements = document.querySelectorAll(".blog-carousel");
  if (!!blog_carousel_elements) initiateCarousel(blog_carousel_elements, {
    type: "carousel",
    perView: 3,
    gap: 30,
    keyboard: true,
    animationDuration: 800,
    breakpoints: {
      1141: {
        peek: {
          before: 0,
          after: 0
        }
      },
      768: {
        perView: 2,
        startAt: 0,
        peek: {
          before: 0,
          after: 100
        }
      },
      600: {
        perView: 1,
        startAt: 0,
        peek: {
          before: 0,
          after: 40
        }
      }
    }
  });
  var blog_stories_carousel_elements = document.getElementById("blog-stories-carousel");
  var blog_stories_carousel = new Glide(blog_stories_carousel_elements, {
    perView: 2,
    bound: true,
    focusAt: 0,
    keyboard: true,
    rewind: false,
    gap: 30,
    animationDuration: 800,
    breakpoints: {
      1141: {
        peek: {
          before: 0,
          after: 0
        }
      },
      768: {
        startAt: 0,
        peek: {
          before: 0,
          after: 100
        }
      },
      600: {
        perView: 1,
        startAt: 0,
        peek: {
          before: 0,
          after: 40
        }
      }
    }
  });
  if (!!blog_stories_carousel_elements) blog_stories_carousel.mount({
    ArrowDisabler: ArrowDisabler
  });
  var blog_hero_carousel_element = document.querySelectorAll("#blog-hero-carousel");
  if (!!blog_hero_carousel_element) {
    initiateCarousel(blog_hero_carousel_element, {
      type: "carousel",
      focusAt: "center",
      animationDuration: 500,
      animationTimingFunc: "linear",
      perView: 1
    });

    // Glide.js clones slides on render. Find them here and for buttons
    // otherwise focus will be offscreen
    var cloneSlideButtons = document.querySelectorAll(".glide__slide--clone .btn");
    cloneSlideButtons.forEach(function (slide) {
      slide.tabIndex = "-1";
    });
  }
  function setUpBlogHeroCarouselEvents(glide) {
    var blogCarouselId = "#blog-hero-carousel";
    var blogCarouselItemClass = ".blog-carousel-item";
    var blogCarouselGlideSlideClass = ".glide__slide";
    var blogCarouselButtonClass = ".blog-hero-btn a";
    var blogCarouselPrev = document.querySelector("#blog-hero-carousel .blog-hero-carousel-prev");
    var blogCarouselNext = document.querySelector("#blog-hero-carousel .blog-hero-carousel-next");
    glide.on("mount.after", function () {
      document.querySelector("".concat(blogCarouselId, " ").concat(blogCarouselItemClass).concat(blogCarouselGlideSlideClass, "--active ").concat(blogCarouselButtonClass)).tabIndex = "0";
    });
    glide.on("run.after", function (Events) {
      var activePanel = document.querySelector("".concat(blogCarouselId, " ").concat(blogCarouselItemClass).concat(blogCarouselGlideSlideClass, "--active"));
      var inactivePanels = document.querySelectorAll("".concat(blogCarouselId, " ").concat(blogCarouselItemClass, ":not(").concat(blogCarouselGlideSlideClass, "--active)"));
      inactivePanels.forEach(function (panel) {
        if (!panel.classList.contains("slide--clone")) panel.querySelector(blogCarouselButtonClass).tabIndex = "-1";
      });
      activePanel.querySelector(blogCarouselButtonClass).tabIndex = "0";
    });
  }
  var video_carousel_element = document.querySelectorAll("#video-carousel-wrap");
  var screen_width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  var peek_width = screen_width - 1080;
  if (!!video_carousel_element) initiateCarousel(video_carousel_element, {
    type: "carousel",
    focusAt: "center",
    animationDuration: 800,
    animationTimingFunc: "linear",
    keyboard: true,
    perView: 1,
    peek: {
      before: peek_width / 2,
      after: peek_width / 2
    },
    breakpoints: {
      1079: {
        perView: 1,
        peek: {
          before: 0,
          after: 0
        }
      },
      600: {
        perView: 1,
        peek: {
          before: 0,
          after: 0
        }
      }
    }
  });
  $("#video-carousel-wrap .video-carousel-prev, #video-carousel-wrap .video-carousel-next, .glide__bullet").click(function () {
    setTimeout(function () {
      var slickActive = $("#video-carousel-wrap .glide__bullets .glide__bullet--active").attr("aria-label");
      $("#video-carousel-wrap .slide-count").text(slickActive);
    }, 1000);
  });
}

// Fix for Jira issue FG-6928
// Adjust breadcrumb placement for /blog and /protection-recovery/disaster-tool pages
document.addEventListener("DOMContentLoaded", function () {
  var path = window.location.pathname;
  var breadcrumbs = document.getElementById("block-farmers-update-breadcrumbs");
  if (path.includes("/blog")) {
    var carouselContainer = document.getElementById("blog-hero-carousel") || document.querySelector(".usa-hero");
    if (breadcrumbs && carouselContainer && carouselContainer.parentNode) {
      // Move breadcrumbs after the carousel container
      carouselContainer.parentNode.insertBefore(breadcrumbs, carouselContainer.nextSibling);
    }
    var bullets = document.querySelector("#blog-hero-carousel .glide__bullets");
    if (bullets) {
      bullets.style.bottom = "35px";
      var glide = document.querySelector(".glide");
      if (glide) {
        glide.style.marginBottom = "-60px";
      }
    }
  }
  if (path.includes("/protection-recovery/disaster-tool")) {
    var heroContainer = document.querySelector(".background-image.background-image-header");
    if (breadcrumbs && heroContainer && heroContainer.parentNode) {
      // Move breadcrumbs after the hero container
      heroContainer.parentNode.insertBefore(breadcrumbs, heroContainer.nextSibling);
    }
  }
});

// Fix for Jira issue 4880
// Synch Blog carousel position with keyboard interactions

document.addEventListener('DOMContentLoaded', function () {
  var targetElements = document.querySelectorAll('.blog-stories-item.glide__slide');
  var blogButtonPrev = document.querySelector("button.blog-stories-carousel-prev");
  var blogButtonNext = document.querySelector("button.blog-stories-carousel-next");
  if (!blogButtonPrev || !blogButtonNext || !targetElements) {
    //console.log('Blog carousel or Blog carousel buttons not found');
    return;
  }
  var currentSlideindex = -1;

  // Loop through each target (Blog slide) elements
  targetElements.forEach(function (targetElement, index) {
    var linkElement = targetElement.querySelector('a');
    if (!linkElement) return;

    // Add a focus event listener to each target element
    targetElement.style.border = "1px solid transparent";
    linkElement.addEventListener('focus', function () {
      if (currentSlideindex == -1) currentSlideindex = index;
      if (index > currentSlideindex) {
        blogButtonNext.click();
        currentSlideindex = index;
      }
      if (index < currentSlideindex) {
        blogButtonPrev.click();
        currentSlideindex = index;
      }

      // Add generic border to slide in focus to improve visibility of the active slide
      targetElement.style.border = "1px solid #999";
    });

    // Add a blur event listener to each target element
    linkElement.addEventListener('blur', function () {
      targetElement.style.border = "1px solid transparent";
    });
  });
});

// Fix for Jira issue 4875
// Screen Reader Needs to Announce Slides

document.addEventListener('DOMContentLoaded', function () {
  var blogButtonPrev = document.querySelector("button.blog-hero-carousel-prev");
  var blogButtonNext = document.querySelector("button.blog-hero-carousel-next");
  if (!blogButtonPrev || !blogButtonNext || !targetElements) {
    //console.log('Blog carousel or Blog carousel buttons not found');
    return;
  }
  var carouselSlides = document.querySelectorAll(".blog-hero-carousel .glide__track .blog-carousel-item");
  var numberofSlides = carouselSlides.length - 2;
  var carouselSlidesAriaText = [];
  var blogHeroCarousel = document.querySelector(".blog-hero-carousel");
  if (!blogHeroCarousel) {
    console.log('Blog hero carousel not found');
    return;
  }

  // Build array of Aria text sentences for all slides
  carouselSlides.forEach(function (slide, index) {
    var mainSlideTitle = slide.querySelector('h1');
    if (mainSlideTitle && index > 0) {
      carouselSlidesAriaText.push("Slide " + index + " of " + numberofSlides + " " + mainSlideTitle.textContent.trim());
    }
  });
  carouselSlidesAriaText.pop();

  // Return index of current carousel slide
  function carouselSlideIndex() {
    var activeBullet = document.querySelector('.glide__bullet--active');
    if (activeBullet) {
      var bullets = document.querySelectorAll('.glide__bullet');
      var activeBulletIndex = Array.from(bullets).indexOf(activeBullet);
      return activeBulletIndex + 1;
    }
    return -1;
  }

  // Carousel Next button clicked, override Aria text to give slide position & slide contents summary
  // Fallback to existing button Aria text if errors occur
  blogButtonNext.addEventListener('click', function () {
    blogHeroCarousel.setAttribute("aria-live", "off");
    setTimeout(function () {
      blogHeroCarousel.setAttribute("aria-live", "on");
    }, 750);
    var index = carouselSlideIndex();
    if (index !== -1) {
      blogButtonNext.setAttribute("aria-label", carouselSlidesAriaText[index % numberofSlides]);
    }
  });

  // Carousel Previous button clicked, override Aria text to give slide position & slide contents summary
  // Fallback to existing button Aria text if errors occur
  blogButtonPrev.addEventListener('click', function () {
    var index = carouselSlideIndex();
    if (index !== -1) {
      var prevIndex = index - 2 < 0 ? numberofSlides - 1 : index - 2;
      blogHeroCarousel.setAttribute("aria-live", "off");
      setTimeout(function () {
        blogHeroCarousel.setAttribute("aria-live", "on");
      }, 750);
      blogButtonPrev.setAttribute("aria-label", carouselSlidesAriaText[prevIndex % numberofSlides]);
    }
  });
});

},{"../farmers-gov-design-system/js/_utils/general_utils":1,"./_utils/blog/_blog_utils":7}]},{},[11]);
